import { TidalButton } from '../common/button';

export const MerchantItemForm = ({ formik, handleClose, categories }) => {
  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-1/3 my-3 mx-auto max-w-3xl max-h-200 overflow-scroll">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
              <p className="text-2xl font-semibold">Update Item</p>
              <button
                className="p-1 ml-auto bg-transparent border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                onClick={handleClose}
              >
                <span className="bg-transparent text-black h-8 w-8 text-2xl block outline-none focus:outline-none">
                  ×
                </span>
              </button>
            </div>
            {/*body*/}
            <div className="relative p-6 flex-auto max-h-96 overflow-scroll">
              <form>
                <div className="mb-4">
                  <label
                    htmlFor="categoryId"
                    className="block text-left mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Select a category
                  </label>
                  <select
                    id="categoryId"
                    name="categoryId"
                    value={formik.values.categoryId}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  >
                    <option selected>Choose a category</option>
                    {(categories || []).map((category) => (
                      <option value={category.id}>{category.name}</option>
                    ))}
                  </select>
                  {formik.errors.categoryId && formik.touched.categoryId && (
                    <p className="mt-2 text-sm text-red-600 dark:text-red-500">
                      <span className="font-medium">Oops!</span>{' '}
                      {formik.errors.categoryId}
                    </p>
                  )}
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="name"
                    className="block text-left mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Item Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Store Name / Item Name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.errors.name && formik.touched.name && (
                    <p className="mt-2 text-sm text-red-600 dark:text-red-500">
                      <span className="font-medium">Oops!</span>{' '}
                      {formik.errors.name}
                    </p>
                  )}
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="name"
                    className="block text-left mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Item URL Slug
                  </label>
                  <input
                    type="text"
                    id="slug"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="item-slug"
                    value={formik.values.slug}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.errors.slug && formik.touched.slug && (
                    <p className="mt-2 text-sm text-red-600 dark:text-red-500">
                      <span className="font-medium">Oops!</span>{' '}
                      {formik.errors.slug}
                    </p>
                  )}
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="description"
                    className="block text-left mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Item Description
                  </label>
                  <textarea
                    id="description"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Item Description (MD Supported)"
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.errors.description && formik.touched.description && (
                    <p className="mt-2 text-sm text-red-600 dark:text-red-500">
                      <span className="font-medium">Oops!</span>{' '}
                      {formik.errors.description}
                    </p>
                  )}
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="description"
                    className="block text-left mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Item Meta Description
                  </label>
                  <textarea
                    id="metaDescription"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Item Meta Description (200 char max)"
                    value={formik.values.metaDescription}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.errors.metaDescription &&
                    formik.touched.metaDescription && (
                      <p className="mt-2 text-sm text-red-600 dark:text-red-500">
                        <span className="font-medium">Oops!</span>{' '}
                        {formik.errors.metaDescription}
                      </p>
                    )}
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="name"
                    className="block text-left mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Item Order (Ascending)
                  </label>
                  <input
                    type="number"
                    id="categoryItemOrder"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="0"
                    value={formik.values.categoryItemOrder}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.errors.categoryItemOrder &&
                    formik.touched.categoryItemOrder && (
                      <p className="mt-2 text-sm text-red-600 dark:text-red-500">
                        <span className="font-medium">Oops!</span>{' '}
                        {formik.errors.categoryItemOrder}
                      </p>
                    )}
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="imageUrl"
                    className="block text-left mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Item Image
                  </label>
                  <input
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    type="text"
                    name="imageUrl"
                    id="imageUrl"
                    placeholder="Image URL for Item"
                    value={formik.values.imageUrl}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.errors.imageUrl && formik.touched.imageUrl && (
                    <p className="mt-2 text-sm text-red-600 dark:text-red-500">
                      <span className="font-medium">Oops!</span>{' '}
                      {formik.errors.imageUrl}
                    </p>
                  )}
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="logoUrl"
                    className="block text-left mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Logo Image
                  </label>
                  <input
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    type="text"
                    name="logoUrl"
                    id="logoUrl"
                    placeholder="Logo URL for Item"
                    value={formik.values.logoUrl}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.errors.logoUrl && formik.touched.logoUrl && (
                    <p className="mt-2 text-sm text-red-600 dark:text-red-500">
                      <span className="font-medium">Oops!</span>{' '}
                      {formik.errors.logoUrl}
                    </p>
                  )}
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="bannerUrl"
                    className="block text-left mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Banner Image
                  </label>
                  <input
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    type="text"
                    name="bannerUrl"
                    id="bannerUrl"
                    placeholder="Banner URL for Item"
                    value={formik.values.bannerUrl}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.errors.bannerUrl && formik.touched.bannerUrl && (
                    <p className="mt-2 text-sm text-red-600 dark:text-red-500">
                      <span className="font-medium">Oops!</span>{' '}
                      {formik.errors.bannerUrl}
                    </p>
                  )}
                </div>
              </form>
            </div>
            {/*footer*/}
            <div className="flex flex-wrap items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
              <div className="w-1/2">
                <button
                  className="text-red-500 background-transparent font-bold px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={handleClose}
                >
                  Close
                </button>
              </div>
              <div className="w-1/2">
                <TidalButton
                  isLoading={formik.isSubmitting}
                  disabled={!formik.isValid}
                  type="info"
                  tint={false}
                  text="Save"
                  onClick={formik.handleSubmit}
                />
              </div>
              {formik.status !== 'valid' && (
                <div className="w-full text-center pt-2">
                  <p>Failed to create item: {formik.status?.message}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
};
